import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { enumMapper, EnumSortDirection, RobotHostingType, RobotType, } from '@models';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { EnvironmentService, RobotService, } from '@services';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
var RobotEnvironmentSource = /** @class */ (function () {
    function RobotEnvironmentSource(_robots, _environments) {
        this._robots = _robots;
        this._environments = _environments;
    }
    Object.defineProperty(RobotEnvironmentSource.prototype, "mapper", {
        get: function () {
            return this._robots.mapper;
        },
        enumerable: true,
        configurable: true
    });
    RobotEnvironmentSource.prototype.get = function (qo) {
        return this._environments.getRobotsIn(this.environmentId, qo);
    };
    return RobotEnvironmentSource;
}());
export { RobotEnvironmentSource };
var EnvironmentRobotsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(EnvironmentRobotsGridComponent, _super);
    function EnvironmentRobotsGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.RobotHostingType = RobotHostingType;
        _this.RobotType = RobotType;
        _this.close = new EventEmitter();
        _this.isInConflictingState$ = new Subject();
        _this.typeList = enumMapper(RobotType, {
            resourceKey: 'RobotType',
            sort: EnumSortDirection.ascending,
        });
        _this.hostingTypeList = enumMapper(RobotHostingType, {
            resourceKey: 'RobotHostingType',
        });
        _this._environmentService = _this._injector.get(EnvironmentService);
        return _this;
    }
    Object.defineProperty(EnvironmentRobotsGridComponent.prototype, "environmentId", {
        set: function (value) {
            var svc = this._service;
            if (!svc ||
                isNaN(value) ||
                svc.environmentId === value) {
                return;
            }
            svc.environmentId = value;
            this._environmentId = value;
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    EnvironmentRobotsGridComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._environmentService
            .getRobotIdsForEnvironment(this._environmentId)
            .subscribe(function (robotIds) {
            var _a;
            var robots = robotIds;
            (_a = _this._grid.selectionManager).select.apply(_a, robots);
            _this._grid.selectionManager.snapshot();
        });
    };
    EnvironmentRobotsGridComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.close.complete();
    };
    EnvironmentRobotsGridComponent.prototype.updateEnvironment = function () {
        var _this = this;
        this.loading$.next(true);
        this._environmentService.setRobots(this._environmentId, this._grid.selectionManager.difference).pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () { _this.close.emit(); }, function (errorResponse) {
            var _a;
            if (errorResponse.status === 409) {
                _this.isInConflictingState$.next(true);
                var failedItems = errorResponse
                    .error
                    .resourceIds
                    .map(function (id) { return ({ id: id }); });
                (_a = _this._grid.selectionManager).deselect.apply(_a, failedItems);
                _this._refresh$.next();
            }
        });
    };
    return EnvironmentRobotsGridComponent;
}(ODataGridComponent));
export { EnvironmentRobotsGridComponent };
